import React from "react";
import { Grid } from "@material-ui/core";
import PatientForm from "../../../../forms/autorizacaoEspecial/PatientForm";
import FormBase from "../../../../forms/FormBase";

import { InternacaoOptions } from "../../../../data/Internacao";
import { TipoInternacaoOptions } from "../../../../data/TipoInternacao";
import Controls from "../../../../components/controls/Controls";
import { InputType } from "../../../../components/controls/Input";

interface PatientComponentProps {
  PatientForm: PatientForm;
  onInputChange: (name: string, form: FormBase, value: any) => void;
}

/* eslint-disable no-useless-escape */
export default function PatientComponent(props: PatientComponentProps) {
  return (
    <Grid container spacing={5}>
      <Grid item xs={12} sm={12}>
        <Controls.Input
          name="Name"
          label="Nome completo *"
          maxLength={60}
          placeholder="Digite o seu nome completo"
          value={props.PatientForm.Name.Value}
          onChange={(e) => {
            e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
            props.onInputChange("Name", props.PatientForm, e.target.value);
          }}
          onBlur={(e) => {
            props.onInputChange("Name", props.PatientForm, e.target.value);
          }}
          error={props.PatientForm.Name.Error}
        />
      </Grid>

      <Grid item xs={6} sm={6}>
        <Controls.DatePicker
          name="BirthDate"
          label="Data de Nascimento *"
          maxDate={new Date()}
          value={props.PatientForm.BirthDate.Value}
          onChange={(e) => {
            props.onInputChange("BirthDate", props.PatientForm, e.target.value);
          }}
          onBlur={(e) => {
            props.onInputChange("BirthDate", props.PatientForm, e.target.value);
          }}
          error={props.PatientForm.BirthDate.Error}
        />
      </Grid>

      <Grid item xs={6} sm={6}>
        <Controls.Input
          name="RG"
          label="RG *"
          maxLength={15}
          placeholder={"Digite o Número do RG"}
          value={props.PatientForm.RG.Value}
          onChange={(e) => {
            e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\=?;:'",¨<>\{\}\[\]\\\/]/gi, '');
            props.onInputChange("RG", props.PatientForm, e.target.value);
          }}
          onBlur={(e) => {
            props.onInputChange("RG", props.PatientForm, e.target.value);
          }}
          error={props.PatientForm.RG.Error}
        />
      </Grid>

      <Grid item xs={6} sm={6}>
        <Controls.Input
          name="CPF"
          label="CPF *"
          type={InputType.CPF}
          placeholder={"___.___.___-__"}
          value={props.PatientForm.CPF.Value}
          onChange={(e) => {
            props.onInputChange("CPF", props.PatientForm, e.target.value);
          }}
          onBlur={(e) => {
            props.onInputChange("CPF", props.PatientForm, e.target.value);
          }}
          error={props.PatientForm.CPF.Error}
        />
      </Grid>

      <Grid item xs={6} sm={6}>
        <Controls.DatePicker
          name="ExpectedDateReception"
          label="Data prevista da internação *"
          value={props.PatientForm.ExpectedDateReception.Value}
          onChange={(e) => {
            props.onInputChange(
              "ExpectedDateReception",
              props.PatientForm,
              e.target.value
            );
          }}
          onBlur={(e) => {
            props.onInputChange(
              "ExpectedDateReception",
              props.PatientForm,
              e.target.value
            );
          }}
          error={props.PatientForm.ExpectedDateReception.Error}
        />
      </Grid>

      <Grid item xs={6} sm={6}>
        <Controls.Input
          name="TimePermanenceInDays"
          label="Tempo de Permanência (em dias) *"
          maxLength={4}
          type={InputType.NUMERICO}
          placeholder="Digite o tempo de permanência"
          value={props.PatientForm.TimePermanenceInDays.Value}
          onChange={(e) => {
            props.onInputChange(
              "TimePermanenceInDays",
              props.PatientForm,
              e.target.value
            );
          }}
          onBlur={(e) => {
            props.onInputChange(
              "TimePermanenceInDays",
              props.PatientForm,
              e.target.value
            );
          }}
          error={props.PatientForm.TimePermanenceInDays.Error}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <Controls.RadioGroup
          name="ServiceType"
          label="Internação *"
          value={props.PatientForm.ServiceType.Value}
          onChange={(e) => {
            props.onInputChange(
              "ServiceType",
              props.PatientForm,
              e.target.value
            );
          }}
          items={InternacaoOptions}
          error={props.PatientForm.ServiceType.Error}
        />
      </Grid>

      {
        props.PatientForm.ServiceType.Value === "Convenio" ?
          <React.Fragment>
            <Grid item xs={4} sm={4}>
              <Controls.Input
                placeholder="Digite o nome da operadora"
                name="HealthInsurance"
                label="Operadora *"
                maxLength={255}
                value={props.PatientForm.HealthInsurance.Value}
                onChange={(e) => {
                  props.onInputChange(
                    "HealthInsurance",
                    props.PatientForm,
                    e.target.value
                  );
                }}
                onBlur={(e) => {
                  props.onInputChange(
                    "HealthInsurance",
                    props.PatientForm,
                    e.target.value
                  );
                }}
                error={props.PatientForm.HealthInsurance.Error}
              />
            </Grid>

            <Grid item xs={4} sm={4}>
              <Controls.Input
                name="Category"
                placeholder="Digite a categoria"
                label="Categoria *"
                maxLength={80}
                value={props.PatientForm.Category.Value}
                onChange={(e) => {
                  props.onInputChange("Category", props.PatientForm, e.target.value);
                }}
                onBlur={(e) => {
                  props.onInputChange("Category", props.PatientForm, e.target.value);
                }}
                error={props.PatientForm.Category.Error}
              />
            </Grid>

            <Grid item xs={4} sm={4}>
              <Controls.Input
                name="Plan"
                placeholder="Digite o Plano"
                label="Plano *"
                maxLength={80}
                value={props.PatientForm.Plan.Value}
                onChange={(e) => {
                  props.onInputChange("Plan", props.PatientForm, e.target.value);
                }}
                onBlur={(e) => {
                  props.onInputChange("Plan", props.PatientForm, e.target.value);
                }}
                error={props.PatientForm.Plan.Error}
              />
            </Grid>
          </React.Fragment>
          : null
      }



      <Grid item xs={12} sm={12}>
        <Controls.RadioGroup
          name="HospitalType"
          label="Tipo Internação *"
          value={props.PatientForm.HospitalType.Value}
          onChange={(e) => {
            props.onInputChange(
              "HospitalType",
              props.PatientForm,
              e.target.value
            );
          }}
          items={TipoInternacaoOptions}
          error={props.PatientForm.HospitalType.Error}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <Controls.Input
          name="DiagnosticHypothesis"
          placeholder="Inserir orientação (Favor descrever a hipótese por extenso, não inserir códigos)"
          label="Hipótese Diagnóstica *"
          maxLength={500}
          multiline
          rows={3}
          value={props.PatientForm.DiagnosticHypothesis.Value}
          onChange={(e) => {
            props.onInputChange(
              "DiagnosticHypothesis",
              props.PatientForm,
              e.target.value
            );
          }}
          onBlur={(e) => {
            props.onInputChange(
              "DiagnosticHypothesis",
              props.PatientForm,
              e.target.value
            );
          }}
          error={props.PatientForm.DiagnosticHypothesis.Error}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <Controls.Input
          name="Procedure"
          placeholder="Inserir orientação (Favor descrever o procedimento por extenso, não inserir códigos)"
          label="Procedimento(s) proposta(s) para solicitações de acompanhamento cirúrgico *"
          value={props.PatientForm.Procedure.Value}
          maxLength={500}
          multiline
          rows={3}
          onChange={(e) => {
            props.onInputChange("Procedure", props.PatientForm, e.target.value);
          }}
          onBlur={(e) => {
            props.onInputChange("Procedure", props.PatientForm, e.target.value);
          }}
          error={props.PatientForm.Procedure.Error}
        />
      </Grid>
    </Grid>
  );
}
